// import React, { useState, useCallback } from "react";
// import { 
//   FaShieldAlt, 
//   FaCheckCircle, 
//   FaTimes,
//   FaBook
// } from "react-icons/fa";

// const PrivacyPolicy = ({ isMobile }) => {
//     const [showDocumentViewer, setShowDocumentViewer] = useState(false);
//     const [currentDocument, setCurrentDocument] = useState({ title: '', content: '', type: '' });

//     const documentContents = {
//         privacyPolicy: {
//             title: "Privacy Policy - FoodLeague Platform",
//             content: (
//                 <div style={{ lineHeight: '1.6', textAlign: 'center', padding: '50px 20px' }}>
//                     <FaBook aria-hidden="true" style={{ fontSize: '64px', color: '#A055B0', marginBottom: '20px' }} />
//                     <h3>Privacy Policy Content</h3>
//                     <p>This document content has been removed as per requirements.</p>
//                 </div>
//             )
//         }
//     };

//     const handleViewDocument = useCallback((type) => {
//         setCurrentDocument({
//             title: documentContents[type].title,
//             content: documentContents[type].content,
//             type: type
//         });
//         setShowDocumentViewer(true);
//     }, [documentContents]);

//     const handleCloseDocumentViewer = useCallback(() => {
//         setShowDocumentViewer(false);
//     }, []);

//     const DocumentViewerModal = ({ isOpen, onClose, title, content }) => {
//         if (!isOpen) return null;
      
//         return (
//           <div style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: 'rgba(0, 0, 0, 0.8)',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             zIndex: 9999,
//             padding: '20px'
//           }}>
//             <div style={{
//               backgroundColor: 'white',
//               borderRadius: '12px',
//               padding: window.innerWidth < 768 ? '15px' : '20px',
//               maxWidth: window.innerWidth < 768 ? '95%' : '80%',
//               width: '100%',
//               maxHeight: window.innerWidth < 768 ? '80vh' : '85vh',
//               display: 'flex',
//               flexDirection: 'column',
//               boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
//               position: 'relative'
//             }}>
//               <div style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 marginBottom: '15px',
//                 paddingBottom: '10px',
//                 borderBottom: '2px solid #A055B0',
//                 flexWrap: 'wrap',
//                 gap: '10px'
//               }}>
//                 <h3 style={{
//                   margin: 0,
//                   color: '#A055B0',
//                   fontSize: window.innerWidth < 768 ? '18px' : '22px',
//                   fontWeight: 'bold',
//                   flex: 1
//                 }}>
//                   {title}
//                 </h3>
                
//                 <button 
//                   onClick={onClose}
//                   aria-label="Close document viewer"
//                   style={{
//                     backgroundColor: '#f44336',
//                     color: 'white',
//                     border: 'none',
//                     padding: window.innerWidth < 768 ? '8px 12px' : '10px 20px',
//                     borderRadius: '5px',
//                     cursor: 'pointer',
//                     fontSize: window.innerWidth < 768 ? '12px' : '14px',
//                     fontWeight: 'bold',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '8px',
//                     transition: 'all 0.3s ease'
//                   }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.backgroundColor = '#d32f2f';
//                     e.currentTarget.style.transform = 'translateY(-2px)';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.backgroundColor = '#f44336';
//                     e.currentTarget.style.transform = 'translateY(0)';
//                   }}
//                 >
//                   <FaTimes aria-hidden="true" /> Close
//                 </button>
//               </div>
      
//               <div style={{
//                 flex: 1,
//                 overflowY: 'auto',
//                 padding: '15px',
//                 backgroundColor: '#f9f9f9',
//                 borderRadius: '8px',
//                 border: '1px solid #ddd',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 color: '#666'
//               }}>
//                 <div style={{ textAlign: 'center' }}>
//                   <FaBook aria-hidden="true" style={{ fontSize: '48px', color: '#A055B0', marginBottom: '15px' }} />
//                   <h4>Document Content Removed</h4>
//                   <p>This document content has been removed as per requirements.</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         );
//       };

//     return (
//         <>
//             <div style={{
//                 backgroundColor: "#fff",
//                 borderRadius: "12px",
//                 padding: isMobile ? "15px" : "25px",
//                 border: "1px solid #e0e0e0",
//                 minHeight: "400px",
//                 overflow: "auto"
//             }}>
//                 <div style={{ marginTop: '10px' }}>
//                     {/* Food Safety & Ingredient Data Collection */}
//                     <div style={{ 
//                         borderRadius: '12px',
//                         marginBottom: '20px',
//                     }}>
//                         <h2 style={{ 
//                             fontSize: isMobile ? '18px' : '22px',
//                             color: '#2e7d32',
//                             marginBottom: '20px',
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '12px'
//                         }}>
//                             <FaShieldAlt aria-hidden="true" />
//                             Food & Beverages Vendor Data Protection
//                         </h2>
                        
//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '10px',
//                             marginBottom: '20px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <h3 style={{ 
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 color: '#2e7d32',
//                                 marginBottom: '15px'
//                             }}>
//                                 🍽️ Food Safety & Ingredient Data Collection
//                             </h3>
//                             <ul style={{ paddingLeft: '20px', fontSize: isMobile ? '14px' : '16px', lineHeight: '1.6' }}>
//                                 <li style={{ marginBottom: '10px' }}>
//                                     <strong>Temperature Monitoring:</strong> We collect and secure temperature logs for refrigeration and cooking equipment to ensure food safety compliance. All temperature data is encrypted and stored for regulatory audits.
//                                 </li>
//                                 <li style={{ marginBottom: '10px' }}>
//                                     <strong>Ingredient Sourcing:</strong> Detailed information about ingredient suppliers, batch numbers, and expiration dates are securely stored with end-to-end encryption to maintain supply chain transparency.
//                                 </li>
//                                 <li style={{ marginBottom: '10px' }}>
//                                     <strong>Preparation Protocols:</strong> Food preparation methods, cooking times, and handling procedures are documented with strict access controls to protect proprietary recipes and ensure consistency.
//                                 </li>
//                             </ul>
//                         </div>

//                         {/* Allergy & Dietary Restriction Management */}
//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '10px',
//                             marginBottom: '20px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <h3 style={{ 
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 color: '#2e7d32',
//                                 marginBottom: '15px'
//                             }}>
//                                 🚫 Allergy & Dietary Restriction Management
//                             </h3>
//                             <ul style={{ paddingLeft: '20px', fontSize: isMobile ? '14px' : '16px', lineHeight: '1.6' }}>
//                                 <li style={{ marginBottom: '10px' }}>
//                                     <strong>Customer Allergy Profiles:</strong> We implement zero-knowledge encryption for sensitive allergy information. Data is anonymized and only accessible to authorized kitchen staff during order preparation.
//                                 </li>
//                                 <li style={{ marginBottom: '10px' }}>
//                                     <strong>Dietary Preferences:</strong> Vegan, vegetarian, gluten-free, and other dietary preferences are stored with explicit customer consent and can be deleted upon request at any time.
//                                 </li>
//                                 <li style={{ marginBottom: '10px' }}>
//                                     <strong>Cross-Contamination Prevention:</strong> Our system tracks and logs allergen-free preparation zones with real-time monitoring to ensure customer safety.
//                                 </li>
//                             </ul>
//                         </div>

//                         {/* Customer Experience & Personalization */}
//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '10px',
//                             marginBottom: '20px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <h3 style={{ 
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 color: '#2e7d32',
//                                 marginBottom: '15px'
//                             }}>
//                                 📊 Customer Experience & Personalization
//                             </h3>
//                             <ul style={{ paddingLeft: '20px', fontSize: isMobile ? '14px' : '16px', lineHeight: '1.6' }}>
//                                 <li style={{ marginBottom: '10px' }}>
//                                     <strong>Menu Preferences:</strong> Customer food preferences, favorite dishes, and order history are analyzed with machine learning algorithms to provide personalized recommendations while maintaining data anonymity.
//                                 </li>
//                                 <li style={{ marginBottom: '10px' }}>
//                                     <strong>Feedback Analysis:</strong> Customer reviews and feedback are processed to improve service quality. All feedback is anonymized after 30 days unless explicit consent is given for longer retention.
//                                 </li>
//                                 <li style={{ marginBottom: '10px' }}>
//                                     <strong>Loyalty Programs:</strong> Points, rewards, and special offers data is protected with bank-level security protocols and regular security audits.
//                                 </li>
//                             </ul>
//                         </div>

//                         {/* Payment & Transaction Security */}
//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '10px',
//                             marginBottom: '20px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <h3 style={{ 
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 color: '#2e7d32',
//                                 marginBottom: '15px'
//                             }}>
//                                 💳 Payment & Transaction Security
//                             </h3>
//                             <ul style={{ paddingLeft: '20px', fontSize: isMobile ? '14px' : '16px', lineHeight: '1.6' }}>
//                                 <li style={{ marginBottom: '10px' }}>
//                                     <strong>PCI-DSS Compliance:</strong> All payment information is tokenized and never stored on our servers. We partner with PCI-DSS Level 1 certified payment processors for maximum security.
//                                 </li>
//                                 <li style={{ marginBottom: '10px' }}>
//                                     <strong>Transaction Analytics:</strong> Purchase patterns and transaction data are analyzed in aggregate form only, with individual customer data never shared with third parties.
//                                 </li>
//                                 <li style={{ marginBottom: '10px' }}>
//                                     <strong>Fraud Prevention:</strong> Real-time fraud detection systems monitor transactions while maintaining customer privacy through advanced encryption techniques.
//                                 </li>
//                             </ul>
//                         </div>
//                     </div>

//                     {/* Enhanced Security Measures */}
//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '12px',
//                         marginBottom: '20px',
//                         backgroundColor: '#e8f5e8'
//                     }}>
//                         <h2 style={{ 
//                             fontSize: isMobile ? '18px' : '22px',
//                             color: '#1b5e20',
//                             textAlign: 'center',
//                             marginBottom: '20px'
//                         }}>
//                             🛡️ Enhanced Security Measures for Food Businesses
//                         </h2>
//                         <div style={{
//                             display: 'grid',
//                             gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
//                             gap: '15px',
//                             fontSize: isMobile ? '14px' : '15px'
//                         }}>
//                             <div style={{ padding: '15px', borderRadius: '8px', backgroundColor: '#f5f5f5' }}>
//                                 <strong style={{ color: '#2e7d32' }}>🧪 Food Safety Data Encryption</strong>
//                                 <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
//                                     All HACCP logs, temperature readings, and safety checks are encrypted using AES-256 encryption with automated backup to secure cloud storage.
//                                 </p>
//                             </div>
//                             <div style={{ padding: '15px', borderRadius: '8px', backgroundColor: '#f5f5f5' }}>
//                                 <strong style={{ color: '#2e7d32' }}>📋 Regulatory Compliance Tracking</strong>
//                                 <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
//                                     Automated tracking of FSSAI regulations, health department requirements, and food safety standards with real-time compliance alerts.
//                                 </p>
//                             </div>
//                             <div style={{ padding: '15px', borderRadius: '8px', backgroundColor: '#f5f5f5' }}>
//                                 <strong style={{ color: '#2e7d32' }}>👥 Staff Access Controls</strong>
//                                 <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
//                                     Role-based access with biometric authentication for sensitive areas like recipe databases and customer allergy information.
//                                 </p>
//                             </div>
//                             <div style={{ padding: '15px', borderRadius: '8px', backgroundColor: '#f5f5f5' }}>
//                                 <strong style={{ color: '#2e7d32' }}>🔄 Supply Chain Transparency</strong>
//                                 <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
//                                     Blockchain-based tracking for ingredient sourcing with immutable records for quality assurance and recall management.
//                                 </p>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Data Retention & Customer Rights */}
//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '10px',
//                         marginBottom: '20px',
//                         backgroundColor: '#f9f9f9'
//                     }}>
//                         <h2 style={{ 
//                             fontSize: isMobile ? '16px' : '18px',
//                             color: '#e65100',
//                             marginBottom: '20px'
//                         }}>
//                             📜 Data Retention & Customer Rights
//                         </h2>
//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '8px',
//                             marginBottom: '20px',
//                             backgroundColor: '#fff5f0'
//                         }}>
//                             <strong>Data Retention Periods:</strong>
//                             <ul style={{ paddingLeft: '20px', marginTop: '10px', fontSize: '14px' }}>
//                                 <li>Order history: 7 years for tax purposes</li>
//                                 <li>Customer preferences: 2 years of active use</li>
//                                 <li>Feedback and reviews: 3 years</li>
//                                 <li>Allergy information: Deleted upon customer request or after 1 year of inactivity</li>
//                                 <li>Payment information: Not stored - processed via tokenization</li>
//                             </ul>
//                         </div>
//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '8px',
//                             backgroundColor: '#fff5f0'
//                         }}>
//                             <strong>Customer Rights:</strong>
//                             <ul style={{ paddingLeft: '20px', marginTop: '10px', fontSize: '14px' }}>
//                                 <li>Right to access personal data</li>
//                                 <li>Right to correct inaccurate information</li>
//                                 <li>Right to delete personal data (with exceptions for legal requirements)</li>
//                                 <li>Right to data portability</li>
//                                 <li>Right to object to processing</li>
//                             </ul>
//                         </div>
//                     </div>

//                     {/* Privacy Commitment */}
//                     <div style={{ 
//                         padding: '20px', 
//                         borderRadius: '10px',
//                         marginTop: '20px',
//                         textAlign: 'center',
//                         backgroundColor: '#e3f2fd'
//                     }}>
//                         <h2 style={{ 
//                             fontSize: isMobile ? '16px' : '18px',
//                             color: '#1565c0',
//                             marginBottom: '15px'
//                         }}>
//                             🔐 Our Privacy Commitment to Food & Beverage Vendors
//                         </h2>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', lineHeight: '1.6', color: '#333', marginBottom: '15px' }}>
//                             We understand the unique privacy challenges faced by food and beverage businesses. Our platform is designed with industry-specific security measures, 
//                             ensuring that your customer data, proprietary recipes, and business operations remain protected while delivering exceptional dining experiences.
//                         </p>
//                         <div style={{ 
//                             marginTop: '10px', 
//                             padding: '15px', 
//                             borderRadius: '8px',
//                             display: 'inline-block',
//                             backgroundColor: '#bbdefb'
//                         }}>
//                             <strong style={{ color: '#1565c0' }}>24/7 Privacy Support:</strong> Dedicated team available for food safety data emergencies
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <DocumentViewerModal 
//                 isOpen={showDocumentViewer}
//                 onClose={handleCloseDocumentViewer}
//                 title={currentDocument.title}
//                 content={currentDocument.content}
//             />
//         </>
//     );
// };

// export default PrivacyPolicy;















// import React, { useState, useCallback } from "react";
// import { 
//   FaShieldAlt, 
//   FaTimes,
//   FaBook
// } from "react-icons/fa";

// const PrivacyPolicy = ({ isMobile }) => {
//   const [showDocumentViewer, setShowDocumentViewer] = useState(false);
//   const [currentDocument, setCurrentDocument] = useState({ title: '', content: '', type: '' });

//   const handleCloseDocumentViewer = useCallback(() => {
//     setShowDocumentViewer(false);
//   }, []);

//   const DocumentViewerModal = ({ isOpen, onClose, title }) => {
//     if (!isOpen) return null;

//     return (
//       <div style={{
//         position: 'fixed',
//         inset: 0,
//         backgroundColor: 'rgba(0,0,0,0.8)',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         zIndex: 9999
//       }}>
//         <div style={{
//           background: '#fff',
//           borderRadius: '12px',
//           width: '90%',
//           maxWidth: '900px',
//           padding: '20px'
//         }}>
//           <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//             <h3 style={{ color: '#A055B0' }}>{title}</h3>
//             <button onClick={onClose} style={{
//               background: '#f44336',
//               color: '#fff',
//               border: 'none',
//               padding: '8px 12px',
//               borderRadius: '6px',
//               cursor: 'pointer'
//             }}>
//               <FaTimes /> Close
//             </button>
//           </div>

//           <div style={{ textAlign: 'center', padding: '40px' }}>
//             <FaBook style={{ fontSize: '48px', color: '#A055B0' }} />
//             <p>Document content restricted for Super Admin access.</p>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <>
//       <div style={{
//         backgroundColor: "#fff",
//         borderRadius: "12px",
//         padding: isMobile ? "15px" : "25px",
//         border: "1px solid #e0e0e0"
//       }}>

//         <h2 style={{
//           fontSize: isMobile ? '18px' : '22px',
//           color: '#1b5e20',
//           display: 'flex',
//           gap: '10px',
//           alignItems: 'center'
//         }}>
//           <FaShieldAlt /> Super Admin Data Governance & Privacy Policy
//         </h2>

//         {/* Platform Data Control */}
//         <section style={{ background: '#f9f9f9', padding: '15px', borderRadius: '10px', marginTop: '20px' }}>
//           <h3>🛠 Platform-Wide Data Management</h3>
//           <ul>
//             <li><strong>User & Vendor Records:</strong> Super Admin has controlled access to all user, vendor, and delivery partner profiles.</li>
//             <li><strong>Operational Logs:</strong> System activity, login logs, API usage, and admin actions are securely logged.</li>
//             <li><strong>Role Hierarchy:</strong> Full control over Admin, Vendor, and Support roles.</li>
//           </ul>
//         </section>

//         {/* Security & Compliance */}
//         <section style={{ background: '#e8f5e8', padding: '15px', borderRadius: '10px', marginTop: '20px' }}>
//           <h3>🔐 Security & Compliance Oversight</h3>
//           <ul>
//             <li><strong>Encryption Standards:</strong> AES-256 encryption for all sensitive system data.</li>
//             <li><strong>Regulatory Monitoring:</strong> GDPR, IT Act, PCI-DSS, and regional compliance tracking.</li>
//             <li><strong>Audit Trails:</strong> Immutable logs for legal and security audits.</li>
//           </ul>
//         </section>

//         {/* Payments & Financial Control */}
//         <section style={{ background: '#f9f9f9', padding: '15px', borderRadius: '10px', marginTop: '20px' }}>
//           <h3>💳 Financial & Transaction Oversight</h3>
//           <ul>
//             <li><strong>Settlement Monitoring:</strong> Track vendor payouts, commissions, and refunds.</li>
//             <li><strong>Fraud Detection:</strong> Platform-level transaction anomaly detection.</li>
//             <li><strong>No Card Storage:</strong> Payments processed via tokenized gateways only.</li>
//           </ul>
//         </section>

//         {/* Data Retention */}
//         <section style={{ background: '#fff5f0', padding: '15px', borderRadius: '10px', marginTop: '20px' }}>
//           <h3>📜 Data Retention Policy</h3>
//           <ul>
//             <li>System logs: 7 years</li>
//             <li>User activity data: 3 years</li>
//             <li>Vendor financial data: 7 years</li>
//             <li>Deleted accounts: Anonymized after legal period</li>
//           </ul>
//         </section>

//         {/* Super Admin Commitment */}
//         <section style={{ background: '#e3f2fd', padding: '20px', borderRadius: '10px', marginTop: '20px', textAlign: 'center' }}>
//           <h3>🛡 Super Admin Responsibility</h3>
//           <p>
//             Super Admin access is strictly monitored and limited to authorized personnel only.
//             All actions are logged to ensure accountability, transparency, and platform trust.
//           </p>
//         </section>
//       </div>

//       <DocumentViewerModal
//         isOpen={showDocumentViewer}
//         onClose={handleCloseDocumentViewer}
//         title={currentDocument.title}
//       />
//     </>
//   );
// };

// export default PrivacyPolicy;
















import React, { useState, useCallback } from "react";
import { 
  FaShieldAlt, 
  FaUserShield,
  FaDatabase,
  FaChartLine,
  FaClipboardCheck, // Replaced FaAudit with FaClipboardCheck
  FaTimes,
  FaBook
} from "react-icons/fa";

const PrivacyPolicy = ({ isMobile }) => {
    const [showDocumentViewer, setShowDocumentViewer] = useState(false);
    const [currentDocument, setCurrentDocument] = useState({ title: '', content: '', type: '' });

    const documentContents = {
        privacyPolicy: {
            title: "Privacy Policy - SuperAdmin Dashboard",
            content: (
                <div style={{ lineHeight: '1.6', textAlign: 'center', padding: '50px 20px' }}>
                    <FaBook aria-hidden="true" style={{ fontSize: '64px', color: '#1a237e', marginBottom: '20px' }} />
                    <h3>SuperAdmin Privacy Policy Content</h3>
                    <p>This document content has been removed as per requirements.</p>
                </div>
            )
        }
    };

    const handleViewDocument = useCallback((type) => {
        setCurrentDocument({
            title: documentContents[type].title,
            content: documentContents[type].content,
            type: type
        });
        setShowDocumentViewer(true);
    }, [documentContents]);

    const handleCloseDocumentViewer = useCallback(() => {
        setShowDocumentViewer(false);
    }, []);

    const DocumentViewerModal = ({ isOpen, onClose, title, content }) => {
        if (!isOpen) return null;
      
        return (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            padding: '20px'
          }}>
            <div style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              padding: window.innerWidth < 768 ? '15px' : '20px',
              maxWidth: window.innerWidth < 768 ? '95%' : '80%',
              width: '100%',
              maxHeight: window.innerWidth < 768 ? '80vh' : '85vh',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
              position: 'relative'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '15px',
                paddingBottom: '10px',
                borderBottom: '2px solid #1a237e',
                flexWrap: 'wrap',
                gap: '10px'
              }}>
                <h3 style={{
                  margin: 0,
                  color: '#1a237e',
                  fontSize: window.innerWidth < 768 ? '18px' : '22px',
                  fontWeight: 'bold',
                  flex: 1
                }}>
                  {title}
                </h3>
                
                <button 
                  onClick={onClose}
                  aria-label="Close document viewer"
                  style={{
                    backgroundColor: '#d32f2f',
                    color: 'white',
                    border: 'none',
                    padding: window.innerWidth < 768 ? '8px 12px' : '10px 20px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: window.innerWidth < 768 ? '12px' : '14px',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#b71c1c';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#d32f2f';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <FaTimes aria-hidden="true" /> Close
                </button>
              </div>
      
              <div style={{
                flex: 1,
                overflowY: 'auto',
                padding: '15px',
                backgroundColor: '#f5f7ff',
                borderRadius: '8px',
                border: '1px solid #ddd',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#666'
              }}>
                <div style={{ textAlign: 'center' }}>
                  <FaBook aria-hidden="true" style={{ fontSize: '48px', color: '#1a237e', marginBottom: '15px' }} />
                  <h4>SuperAdmin Document Content</h4>
                  <p>This document contains sensitive administrative privacy policies and compliance information.</p>
                </div>
              </div>
            </div>
          </div>
        );
      };

    return (
        <>
            <div style={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                padding: isMobile ? "15px" : "25px",
                border: "1px solid #e0e0e0",
                minHeight: "400px",
                overflow: "auto"
            }}>
                <div style={{ marginTop: '10px' }}>
                    {/* SuperAdmin Data Governance */}
                    <div style={{ 
                        borderRadius: '12px',
                        marginBottom: '20px',
                    }}>
                        <h2 style={{ 
                            fontSize: isMobile ? '18px' : '22px',
                            color: '#1a237e',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px'
                        }}>
                            <FaUserShield aria-hidden="true" />
                            SuperAdmin Data Governance & Platform Management
                        </h2>
                        
                        <div style={{ 
                            padding: '15px', 
                            borderRadius: '10px',
                            marginBottom: '20px',
                            backgroundColor: '#f5f7ff'
                        }}>
                            <h3 style={{ 
                                fontSize: isMobile ? '16px' : '18px',
                                color: '#1a237e',
                                marginBottom: '15px'
                            }}>
                                🏢 Platform-Wide Data Management
                            </h3>
                            <ul style={{ paddingLeft: '20px', fontSize: isMobile ? '14px' : '16px', lineHeight: '1.6' }}>
                                <li style={{ marginBottom: '10px' }}>
                                    <strong>Multi-Tenant Data Isolation:</strong> Advanced data partitioning ensures complete separation between different vendor accounts, franchises, and business units with encrypted data boundaries.
                                </li>
                                <li style={{ marginBottom: '10px' }}>
                                    <strong>System-Wide Analytics Access:</strong> Aggregate platform analytics are available while maintaining individual business data confidentiality through differential privacy techniques.
                                </li>
                                <li style={{ marginBottom: '10px' }}>
                                    <strong>Administrative Audit Trails:</strong> All SuperAdmin actions are logged with immutable timestamps, IP tracking, and action verification for complete accountability.
                                </li>
                            </ul>
                        </div>

                        {/* Compliance & Regulatory Oversight */}
                        <div style={{ 
                            padding: '15px', 
                            borderRadius: '10px',
                            marginBottom: '20px',
                            backgroundColor: '#f5f7ff'
                        }}>
                            <h3 style={{ 
                                fontSize: isMobile ? '16px' : '18px',
                                color: '#1a237e',
                                marginBottom: '15px'
                            }}>
                                📋 Compliance & Regulatory Oversight
                            </h3>
                            <ul style={{ paddingLeft: '20px', fontSize: isMobile ? '14px' : '16px', lineHeight: '1.6' }}>
                                <li style={{ marginBottom: '10px' }}>
                                    <strong>GDPR/CCPA Compliance Dashboard:</strong> Centralized interface for managing data subject requests, consent tracking, and compliance reporting across all platform users.
                                </li>
                                <li style={{ marginBottom: '10px' }}>
                                    <strong>Automated Compliance Scanning:</strong> Real-time monitoring of data handling practices against evolving global privacy regulations with automated alerts for violations.
                                </li>
                                <li style={{ marginBottom: '10px' }}>
                                    <strong>Regulatory Reporting:</strong> Generate compliance reports for PCI-DSS, HIPAA (for health-related food services), and food safety regulations with one-click export functionality.
                                </li>
                            </ul>
                        </div>

                        {/* Security Infrastructure Management */}
                        <div style={{ 
                            padding: '15px', 
                            borderRadius: '10px',
                            marginBottom: '20px',
                            backgroundColor: '#f5f7ff'
                        }}>
                            <h3 style={{ 
                                fontSize: isMobile ? '16px' : '18px',
                                color: '#1a237e',
                                marginBottom: '15px'
                            }}>
                                🔐 Security Infrastructure Management
                            </h3>
                            <ul style={{ paddingLeft: '20px', fontSize: isMobile ? '14px' : '16px', lineHeight: '1.6' }}>
                                <li style={{ marginBottom: '10px' }}>
                                    <strong>Enterprise Encryption Management:</strong> Control encryption keys, rotation schedules, and encryption protocols across all platform data stores with military-grade AES-256 encryption.
                                </li>
                                <li style={{ marginBottom: '10px' }}>
                                    <strong>Access Control Governance:</strong> Define and manage role-based access controls (RBAC) with hierarchical permission structures and just-in-time privilege elevation.
                                </li>
                                <li style={{ marginBottom: '10px' }}>
                                    <strong>Security Incident Response:</strong> Coordinate platform-wide security incident responses with automated breach detection and notification workflows.
                                </li>
                            </ul>
                        </div>

                        {/* Vendor & User Administration */}
                        <div style={{ 
                            padding: '15px', 
                            borderRadius: '10px',
                            marginBottom: '20px',
                            backgroundColor: '#f5f7ff'
                        }}>
                            <h3 style={{ 
                                fontSize: isMobile ? '16px' : '18px',
                                color: '#1a237e',
                                marginBottom: '15px'
                            }}>
                                👥 Vendor & User Administration
                            </h3>
                            <ul style={{ paddingLeft: '20px', fontSize: isMobile ? '14px' : '16px', lineHeight: '1.6' }}>
                                <li style={{ marginBottom: '10px' }}>
                                    <strong>Vendor Data Oversight:</strong> Monitor vendor compliance with platform privacy policies through automated audits and manual review capabilities.
                                </li>
                                <li style={{ marginBottom: '10px' }}>
                                    <strong>User Account Management:</strong> Administrative tools for managing user accounts, permissions, and access revocation across the entire platform.
                                </li>
                                <li style={{ marginBottom: '10px' }}>
                                    <strong>Data Retention Enforcement:</strong> Enforce platform-wide data retention policies with automated data lifecycle management and archival procedures.
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Advanced Administrative Controls */}
                    <div style={{ 
                        padding: '15px', 
                        borderRadius: '12px',
                        marginBottom: '20px',
                        backgroundColor: '#e8eaf6'
                    }}>
                        <h2 style={{ 
                            fontSize: isMobile ? '18px' : '22px',
                            color: '#283593',
                            textAlign: 'center',
                            marginBottom: '20px'
                        }}>
                            🛡️ Advanced Administrative Controls & Monitoring
                        </h2>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                            gap: '15px',
                            fontSize: isMobile ? '14px' : '15px'
                        }}>
                            <div style={{ padding: '15px', borderRadius: '8px', backgroundColor: '#f5f7ff' }}>
                                <strong style={{ color: '#1a237e' }}>📊 Platform Analytics Dashboard</strong>
                                <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
                                    Real-time monitoring of data flows, access patterns, and compliance metrics across all platform entities with anomaly detection.
                                </p>
                            </div>
                            <div style={{ padding: '15px', borderRadius: '8px', backgroundColor: '#f5f7ff' }}>
                                <strong style={{ color: '#1a237e' }}>🔍 Forensic Audit Capabilities</strong>
                                <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
                                    Complete reconstruction of data access events with blockchain-verified audit logs for legal and compliance investigations.
                                </p>
                            </div>
                            <div style={{ padding: '15px', borderRadius: '8px', backgroundColor: '#f5f7ff' }}>
                                <strong style={{ color: '#1a237e' }}>⚙️ Policy Configuration Center</strong>
                                <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
                                    Configure and deploy privacy policies, consent mechanisms, and data handling rules across the entire platform ecosystem.
                                </p>
                            </div>
                            <div style={{ padding: '15px', borderRadius: '8px', backgroundColor: '#f5f7ff' }}>
                                <strong style={{ color: '#1a237e' }}>🚨 Emergency Response Protocols</strong>
                                <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
                                    Automated incident response workflows with emergency data isolation and regulatory notification procedures.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Data Retention & Compliance */}
                    <div style={{ 
                        padding: '15px', 
                        borderRadius: '10px',
                        marginBottom: '20px',
                        backgroundColor: '#f5f7ff'
                    }}>
                        <h2 style={{ 
                            fontSize: isMobile ? '16px' : '18px',
                            color: '#0d47a1',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}>
                            <FaClipboardCheck aria-hidden="true" /> {/* Changed from FaAudit */}
                            Platform-Wide Data Retention & Compliance
                        </h2>
                        <div style={{ 
                            padding: '15px', 
                            borderRadius: '8px',
                            marginBottom: '20px',
                            backgroundColor: '#e3f2fd'
                        }}>
                            <strong>Global Data Retention Policies:</strong>
                            <ul style={{ paddingLeft: '20px', marginTop: '10px', fontSize: '14px' }}>
                                <li>Administrative logs: 10 years for compliance and audit purposes</li>
                                <li>Vendor transaction data: 7 years for financial reporting</li>
                                <li>User consent records: 6 years post-account termination</li>
                                <li>Security incident logs: Permanent retention</li>
                                <li>Backup and recovery data: Encrypted and rotated every 90 days</li>
                            </ul>
                        </div>
                        <div style={{ 
                            padding: '15px', 
                            borderRadius: '8px',
                            backgroundColor: '#e3f2fd'
                        }}>
                            <strong>SuperAdmin Compliance Responsibilities:</strong>
                            <ul style={{ paddingLeft: '20px', marginTop: '10px', fontSize: '14px' }}>
                                <li>Regular security assessments and penetration testing</li>
                                <li>Vendor compliance monitoring and enforcement</li>
                                <li>Regulatory reporting and documentation</li>
                                <li>Data protection impact assessments</li>
                                <li>Third-party vendor security audits</li>
                            </ul>
                        </div>
                    </div>

                    {/* SuperAdmin Commitment */}
                    <div style={{ 
                        padding: '20px', 
                        borderRadius: '10px',
                        marginTop: '20px',
                        textAlign: 'center',
                        backgroundColor: '#1a237e',
                        color: 'white'
                    }}>
                        <h2 style={{ 
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '15px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px'
                        }}>
                            <FaShieldAlt aria-hidden="true" />
                            SuperAdmin Privacy & Security Commitment
                        </h2>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', lineHeight: '1.6', marginBottom: '15px' }}>
                            As platform administrators, we maintain the highest standards of data governance, security, and compliance. 
                            Our SuperAdmin tools are designed with enterprise-grade security features to protect the entire platform ecosystem 
                            while ensuring regulatory compliance and operational excellence.
                        </p>
                        <div style={{ 
                            marginTop: '10px', 
                            padding: '15px', 
                            borderRadius: '8px',
                            display: 'inline-block',
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            border: '1px solid rgba(255, 255, 255, 0.2)'
                        }}>
                            <strong>24/7 Security Operations Center:</strong> Dedicated team monitoring platform security and responding to incidents
                        </div>
                    </div>

                    {/* Document Access */}
                    <div style={{ 
                        marginTop: '30px',
                        padding: '20px',
                        borderRadius: '10px',
                        backgroundColor: '#f5f5f5',
                        textAlign: 'center'
                    }}>
                        <button 
                            onClick={() => handleViewDocument('privacyPolicy')}
                            style={{
                                backgroundColor: '#1a237e',
                                color: 'white',
                                border: 'none',
                                padding: '12px 24px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '10px',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#283593';
                                e.currentTarget.style.transform = 'translateY(-2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#1a237e';
                                e.currentTarget.style.transform = 'translateY(0)';
                            }}
                        >
                            <FaBook aria-hidden="true" />
                            View Complete Privacy Policy Document
                        </button>
                        <p style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
                            Contains detailed administrative procedures, compliance requirements, and security protocols
                        </p>
                    </div>
                </div>
            </div>

            <DocumentViewerModal 
                isOpen={showDocumentViewer}
                onClose={handleCloseDocumentViewer}
                title={currentDocument.title}
                content={currentDocument.content}
            />
        </>
    );
};

export default PrivacyPolicy;
